<script>
import GetInvestorErrorNotification from '@/components/Notifications/Investors/GetInvestorErrorNotification';

import pessoasService from '@/services/Pessoas/pessoasService';

import {
  CWLStatusInvestidor,
  PessoaCaracteristica
} from '@/store/cwl_enums';

export default {
  name: 'register-disclaimer',
  computed: {
    currentPessoa() {
      return this.$store.getters.getPessoa;
    },
    role() {
      const value = (this.$store.getters.userClaim && this.$store.getters.userClaim.role)
        ? this.$store.getters.userClaim.role
        : 'investor';
      return value.toLowerCase();
    },
    isUsuario() {
      return this.role == PessoaCaracteristica.InvestorRole;
    },
    isBroker() {
      return this.role == PessoaCaracteristica.Broker;
    },
    CWLStatusInvestidor() {
      return CWLStatusInvestidor;
    },
    isExamInitialized() {
      const user = this.currentPessoa;
      if (!user.exam) return false;
      return true;
    },
    isExamPending() {
      const user = this.currentPessoa;
      return user.exam.exam_approval === 'Pendente';
    }
  },
  data() {
    return {
      
    };
  },
  mounted() {},
  methods: {},
};
</script>

<template>
  <div>
    <div
      v-if="isUsuario && currentPessoa.dados_complementares && currentPessoa.dados_complementares.approvalStatus && currentPessoa.dados_complementares.approvalStatus === CWLStatusInvestidor.Incompleto"
      role="alert"
      class="alert alert-warning"
    >
      <span>
        Seu cadastro não está completo. Por favor verifique os dados que faltam na opção 
        <router-link to="/profile" tag="span" style="cursor: pointer !important;">
          <b>Meus Dados</b>.
        </router-link>
      </span>
    </div>

    <div
      v-if="isBroker && !isExamInitialized"
      role="alert"
      class="alert alert-warning"
    >
      <span>
        Sua prova ainda não foi iniciada. 
        <router-link to="/exam" tag="span" style="cursor: pointer !important;">
          <b>Clique aqui para ir para a prova</b>.
        </router-link>
      </span>
    </div>

    <div
      v-if="isBroker && isExamPending"
      role="alert"
      class="alert alert-info"
    >
      <span style="color: #f3f3f3ee;">
        Sua prova ainda está em correção. 
      </span>
    </div>

    <div
      v-if="isUsuario && currentPessoa.dados_complementares && currentPessoa.dados_complementares.approvalStatus === CWLStatusInvestidor.EmAnalise"
      role="alert"
      class="alert alert-info"
      style="background-color: #00035A !important;"
    >
      <span>
        Seu cadastro já foi preenchido, e está sob analíse. Você será informado por e-mail de qualquer atualização.
      </span>
    </div>

    <div
      v-if="isUsuario && currentPessoa.dados_complementares && currentPessoa.dados_complementares.approvalStatus && currentPessoa.dados_complementares.approvalStatus === CWLStatusInvestidor.Reprovado"
      role="alert"
      class="alert alert-info"
      style="background-color: #00035A !important;"
    >
      <span>
        Seu cadastro foi reprovado. Por favor verifique o motivo e faça as correções na opção 
        <router-link to="/profile" tag="span" style="cursor: pointer !important;">
          <b>Meus Dados</b>.
        </router-link>
      </span>
    </div>
  </div>
</template>
